/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppLogsRouteImport } from './routes/_app/logs'
import { Route as AppFabricateIndexRouteImport } from './routes/_app/fabricate.index'
import { Route as AppFabricateIdRouteImport } from './routes/_app/fabricate.$id'
import { Route as AppInterceptIndexRouteImport } from './routes/_app/intercept.index'
import { Route as AppInterceptNameRouteImport } from './routes/_app/intercept.$name'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsDownstreamsIdRouteImport } from './routes/_app/settings.downstreams.$id'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLogsRoute = AppLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFabricateIndexRoute = AppFabricateIndexRouteImport.update({
  id: '/fabricate/',
  path: '/fabricate/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFabricateIdRoute = AppFabricateIdRouteImport.update({
  id: '/fabricate/$id',
  path: '/fabricate/$id',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInterceptIndexRoute = AppInterceptIndexRouteImport.update({
  id: '/intercept/',
  path: '/intercept/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInterceptNameRoute = AppInterceptNameRouteImport.update({
  id: '/intercept/$name',
  path: '/intercept/$name',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsDownstreamsIdRoute =
  AppSettingsDownstreamsIdRouteImport.update({
    id: '/settings/downstreams/$id',
    path: '/settings/downstreams/$id',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/sign-in': typeof SignInRoute
  '/logs': typeof AppLogsRoute
  '/fabricate/$id': typeof AppFabricateIdRoute
  '/intercept/$name': typeof AppInterceptNameRoute
  '/fabricate/': typeof AppFabricateIndexRoute
  '/intercept/': typeof AppInterceptIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/settings/downstreams/$id': typeof AppSettingsDownstreamsIdRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/logs': typeof AppLogsRoute
  '/': typeof AppIndexRoute
  '/fabricate/$id': typeof AppFabricateIdRoute
  '/intercept/$name': typeof AppInterceptNameRoute
  '/fabricate': typeof AppFabricateIndexRoute
  '/intercept': typeof AppInterceptIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/settings/downstreams/$id': typeof AppSettingsDownstreamsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_app/logs': typeof AppLogsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/fabricate/$id': typeof AppFabricateIdRoute
  '/_app/intercept/$name': typeof AppInterceptNameRoute
  '/_app/fabricate/': typeof AppFabricateIndexRoute
  '/_app/intercept/': typeof AppInterceptIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/settings/downstreams/$id': typeof AppSettingsDownstreamsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/logs'
    | '/fabricate/$id'
    | '/intercept/$name'
    | '/fabricate/'
    | '/intercept/'
    | '/settings/'
    | '/settings/downstreams/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/logs'
    | '/'
    | '/fabricate/$id'
    | '/intercept/$name'
    | '/fabricate'
    | '/intercept'
    | '/settings'
    | '/settings/downstreams/$id'
  id:
    | '__root__'
    | '/_app'
    | '/sign-in'
    | '/_app/logs'
    | '/_app/'
    | '/_app/fabricate/$id'
    | '/_app/intercept/$name'
    | '/_app/fabricate/'
    | '/_app/intercept/'
    | '/_app/settings/'
    | '/_app/settings/downstreams/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/logs': {
      id: '/_app/logs'
      path: '/logs'
      fullPath: '/logs'
      preLoaderRoute: typeof AppLogsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/fabricate/': {
      id: '/_app/fabricate/'
      path: '/fabricate'
      fullPath: '/fabricate/'
      preLoaderRoute: typeof AppFabricateIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/fabricate/$id': {
      id: '/_app/fabricate/$id'
      path: '/fabricate/$id'
      fullPath: '/fabricate/$id'
      preLoaderRoute: typeof AppFabricateIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/intercept/': {
      id: '/_app/intercept/'
      path: '/intercept'
      fullPath: '/intercept/'
      preLoaderRoute: typeof AppInterceptIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/intercept/$name': {
      id: '/_app/intercept/$name'
      path: '/intercept/$name'
      fullPath: '/intercept/$name'
      preLoaderRoute: typeof AppInterceptNameRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/downstreams/$id': {
      id: '/_app/settings/downstreams/$id'
      path: '/settings/downstreams/$id'
      fullPath: '/settings/downstreams/$id'
      preLoaderRoute: typeof AppSettingsDownstreamsIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppLogsRoute: typeof AppLogsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppFabricateIdRoute: typeof AppFabricateIdRoute
  AppInterceptNameRoute: typeof AppInterceptNameRoute
  AppFabricateIndexRoute: typeof AppFabricateIndexRoute
  AppInterceptIndexRoute: typeof AppInterceptIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsDownstreamsIdRoute: typeof AppSettingsDownstreamsIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppLogsRoute: AppLogsRoute,
  AppIndexRoute: AppIndexRoute,
  AppFabricateIdRoute: AppFabricateIdRoute,
  AppInterceptNameRoute: AppInterceptNameRoute,
  AppFabricateIndexRoute: AppFabricateIndexRoute,
  AppInterceptIndexRoute: AppInterceptIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsDownstreamsIdRoute: AppSettingsDownstreamsIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
